import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { View, Text, NativeSyntheticEvent, TextInputKeyPressEventData, StyleSheet } from "react-native";
import { FONT } from "../../../value/staticValues";
import { PAGE_URL } from "../../../value/Url";
import { CustomCancelBtn } from "../../base/CustomCancelBtn";
import { CustomConfirmBtn } from "../../base/CustomConfirmBtn";
import { InputTextUnderLine } from "../../base/CustomInputText";
import AlertContent from "../../base/tamplate/AlartContent";
import LoginBox from "../../base/tamplate/LoginBox";

import { ReactComponent as InfoImg } from "../../../img/ico-msg-info-white.svg";
import { ReactComponent as CloseImg } from "../../../img/ico-prefix-close-white.svg";

interface ResetPwdProps { 
    tabIndex: number;
    nextTabIndexFn: Function;
    email: string;
    setEmail: Function;
    infoText: string;
    infoError: boolean;
    resetPwdResendYn: boolean;
    setResetPwdResendYn: Function;
    navigate: Function;
}
export default function ResetPwd(props:ResetPwdProps) {
    const {t} = useTranslation();

    return (
        <LoginBox>
            <View style={{alignItems:"center", justifyContent: "center"}}>
                <div style={{
                    visibility: props.resetPwdResendYn? "visible" : "hidden",
                    display: "flex", alignItems: "center",
                    position: "absolute", top: -240,
                    width: 660, height: 40,
                    paddingLeft: 10, paddingRight: 10,
                    borderRadius: 20,
                    backgroundColor: "#4a77ff",
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#fff"
                }}>
                    <InfoImg style={{marginRight: 10}}/>
                    {t("FORGET_PASSWORD_EMAIL_RESEND_DETAIL_INFO_MESSAGE")}
                    <CloseImg style={{marginLeft: "auto", cursor: "pointer"}} onClick={() => {props.setResetPwdResendYn(false)}}/>
                </div>
            </View>
            <View style={{
                flexDirection:"row", alignItems: "center", justifyContent: "center",
                marginTop: 60, marginBottom: 60,
            }}>
                {props.tabIndex === 1 ?
                    <Fragment>
                        <View style={{
                            width: 300, marginBottom: "auto"
                        }}>
                            <Text style={{
                                fontFamily: FONT.MEDIUM,
                                fontSize: 24,
                                lineHeight: 36,
                                letterSpacing: -0.16,
                                color: "#333"
                            }}>
                                {t("FORGET_PASSWORD_ASK_MESSAGE")}
                            </Text>
                            <Text style={{...styles.Text, marginTop: 34}}>
                                {t("FORGET_PASSWORD_INFO_MESSAGE")}
                            </Text>
                        </View>

                        <View style={{
                            width: 360,
                            marginLeft: 60
                        }}>
                            <InputTextUnderLine
                                text={t("EMAIL_TEXT")}
                                inputprops={{
                                    placeholder: t("EMAIL_TEXT"),
                                    onChangeText: (Text:string) => props.setEmail(Text.trim()),
                                    onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                        if(event.nativeEvent.key === "Enter") {
                                            props.nextTabIndexFn();
                                        }
                                    }
                                }}
                            />

                            <View style={{ marginTop: 92 }}>
                                <AlertContent
                                    size={33}
                                    text={props.infoText}
                                    error={props.infoError}
                                />
                            </View>
                            

                            <View style={{flexDirection: "row", alignItems: "center", marginTop: 60}}>
                                <CustomCancelBtn
                                    size={{width: 100, height: 52}}
                                    fontsize={12}
                                    text={t("CANCEL_TEXT")}
                                    onPress={() => { props.navigate(-1) }}
                                />
                                <View style={{width: 10}}/>
                                <CustomConfirmBtn
                                    size={{width: 250, height: 52}}
                                    fontsize={12}
                                    disabled={props.email === ""}
                                    text={t("NEXT_TEXT")}
                                    onPress={() => {props.nextTabIndexFn();}}
                                />
                            </View>
                        </View>
                    </Fragment>
                : props.tabIndex === 2 ?
                    <Fragment>
                        <View style={{
                            width: 300, marginBottom: "auto"
                        }}>
                            <Text style={{
                                fontFamily: FONT.MEDIUM,
                                fontSize: 24,
                                lineHeight: 36,
                                letterSpacing: -0.16,
                                color: "#333"
                            }}>
                                {t("EMAIL_SEND_MESSAGE")}
                            </Text>
                        </View>

                        <View style={{
                            width: 360,
                            marginLeft: 60
                        }}>
                            <Text style={{...styles.Text, color: "#333"}}>
                                {t("FORGET_PASSWORD_EMAIL_SEND_COMPLATE_MESSAGE")}
                            </Text>

                            <View style={{
                                marginTop: 40,
                                paddingBottom: 13,
                                borderBottomColor: "#bfbfbf",
                                borderBottomWidth: 1
                            }}>
                                <Text style={{
                                    fontFamily: FONT.BOLD,
                                    fontSize: 16,
                                    color: "#222"
                                }}>
                                    {props.email}
                                </Text>
                            </View>

                            <Text style={{...styles.Text, color: "#333", marginTop: 25, lineHeight: 24,}}>
                                {t("FORGET_PASSWORD_EMAIL_SEND_DETAIL_INFO_MESSAGE")}
                            </Text>

                            <Text style={{
                                marginTop: 30,
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#5c5c5c"
                            }}>
                                {t("NOT_FOUND_EMAIL_MESSAGE")}
                            </Text>

                            <View style={{
                                width: 93,
                                borderBottomColor: "#0853fb",
                                borderBottomWidth: 1,
                            }}>
                                <Text 
                                    style={{
                                        marginTop: 3,
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: "#0853fb"
                                    }}
                                    onPress={() => {
                                        props.setResetPwdResendYn(true);
                                    }}
                                >
                                    {t("EMAIL_RE_SEND_TEXT")}
                                </Text>
                            </View>

                            <View style={{marginTop: 32}}>
                                <CustomConfirmBtn
                                    size={{width: 360, height: 52}}
                                    fontsize={12}
                                    text={t("LOGIN_PAGE_MOVE_TEXT")}
                                    onPress={() => { props.navigate(`${PAGE_URL.LOGIN}`) }}
                                />
                            </View>
                        </View>
                    </Fragment>
                : null
                }
            </View>
        </LoginBox>
    )
}


const styles = StyleSheet.create({
    Text: {
        fontFamily: FONT.REGULAR,
        fontSize: 14,
        lineHeight: 20,
        color: "#8c9299"
    }
})